import { createFileRoute } from '@tanstack/react-router'
import { BpSpinner } from '~/elements'

export const Route = createFileRoute('/workspaces/$workspaceId/loading-bot')({
  component: RouteComponent,
})

function RouteComponent() {
  return (
    <div className="flex h-full flex-col items-center justify-center gap-4">
      <BpSpinner className="h-12 w-12" />
      <p className="text-muted-foreground">Creating your bot...</p>
    </div>
  )
}
